
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class EmploymentTypeDialog extends _Ext.DialogBase<EmploymentTypeRow, any> {
        protected getFormKey() { return EmploymentTypeForm.formKey; }
        protected getIdProperty() { return EmploymentTypeRow.idProperty; }
        protected getLocalTextPrefix() { return EmploymentTypeRow.localTextPrefix; }
        protected getNameProperty() { return EmploymentTypeRow.nameProperty; }
        protected getService() { return EmploymentTypeService.baseUrl; }
        protected getDeletePermission() { return EmploymentTypeRow.deletePermission; }
        protected getInsertPermission() { return EmploymentTypeRow.insertPermission; }
        protected getUpdatePermission() { return EmploymentTypeRow.updatePermission; }

        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        protected form = new EmploymentTypeForm(this.idPrefix);

    }
}